import React from 'react';
import UploadCatalogoFornecedor from '../UploadCatalogoFornecedor/UploadCatalogoFornecedor';

type Props = { closeAction: Function; closeActionSimple: Function };

const UploadPedidoFacil: React.FC<Props> = (props) => <UploadCatalogoFornecedor {...props}
  source="PEDIDO_FACIL" title="Importar catálogo Pedido Fácil (Vercel)"
  instructions="Copie a URL completa do cardápio Pedido Fácil, incluindo o código da loja."
  placeholder="https://cardapio-pedido-facil.vercel.app/?loja=sua-loja"
  loadingMessage="Buscando produtos, complementos e preparando as fotos..." />;

export default UploadPedidoFacil;
